<template>
    <div class="dm-filterbar">
        <button type="button" class="dm-filterbar__close" @click="$emit('chiudi')"
                title="Chiudi filtri" aria-label="Chiudi filtri">
            <i class="ph ph-x" aria-hidden="true"></i>
        </button>
        <div class="card-body py-3">

            <!-- RIGA 1 : date, account, tipologia cliente, cliente -->
            <div class="row g-2">
                <div class="col-12 col-sm-6 col-lg-2">
                    <!-- B2.1C-01C-B: i due campi data usano VueDatePicker invece del controllo
                         nativo di tipo date: quest'ultimo non permette di controllare
                         il formato visualizzato ne il placeholder (li decide il browser). -->
                    <label class="form-label mb-1" for="dm-date-from">Data inizio</label>
                    <VueDatePicker id="dm-date-from"
                                       :model-value="bozza.date_from"
                                       :model-type="formatoDataPicker()"
                                       :formats="{ input: formatoDataPicker() }"
                                       :placeholder="placeholderDataPicker()"
                                       auto-apply text-input
                                       :hide-navigation="['time']"
                                       :clearable="true"
                                       @update:model-value="v => bozza.date_from = v || (``)" />
                </div>
                <div class="col-12 col-sm-6 col-lg-2">
                    <label class="form-label mb-1" for="dm-date-to">Data fine</label>
                    <VueDatePicker id="dm-date-to"
                                       :model-value="bozza.date_to"
                                       :model-type="formatoDataPicker()"
                                       :formats="{ input: formatoDataPicker() }"
                                       :placeholder="placeholderDataPicker()"
                                       auto-apply text-input
                                       :hide-navigation="['time']"
                                       :clearable="true"
                                       @update:model-value="v => bozza.date_to = v || (``)" />
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                    <label class="form-label mb-1" for="dm-account">Account</label>
                    <!-- B2.1C-01E: select ricercabile. Anteprima max 5 righe per non
                         caricare elenchi enormi, ma la ricerca filtra TUTTA la lista
                         in memoria, quindi trova anche i record fuori dai primi 5. -->
                    <Select2 :model-value="bozza.account_id"
                             :options="accountOptions"
                             :disabled="false"
                             :placeholder="bozza.account_id ? accountEtichetta : 'Cerca account...'"
                             @update:modelValue="v => bozza.account_id = v || (``)" />
                </div>
                <div class="col-12 col-sm-6 col-lg-2">
                    <label class="form-label mb-1" for="dm-client-type">Tipologia cliente</label>
                    <select id="dm-client-type" class="form-select form-select-sm"
                            :value="bozza.client_type" @change="onClientTypeChange($event.target.value)">
                        <option value="">Tutte</option>
                        <option v-for="t in clientTypes" :key="t.value" :value="t.value">{{ t.label }}</option>
                    </select>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                    <label class="form-label mb-1" for="dm-client">Cliente</label>
                    <Select2 :model-value="bozza.client_id"
                             :api="apiCliente"
                             :apiselected="apiClienteSelected"
                             :disabled="!bozza.client_type"
                             :placeholder="bozza.client_type ? 'Cerca cliente...' : 'Scegli prima la tipologia'"
                             @update:modelValue="v => bozza.client_id = v || ''" />
                </div>
            </div>

            <!-- RIGA 2 : stato, tipologia evento, progetto, azioni -->
            <div class="row g-2">
                <div class="col-12 col-sm-6 col-lg-2">
                    <label class="form-label mb-1" for="dm-state">Stato progetto</label>
                    <select id="dm-state" class="form-select form-select-sm" v-model="bozza.state_id">
                        <option value="">Tutti gli stati</option>
                        <option v-for="s in statoOptions" :key="s.id" :value="s.id">{{ s.text }}</option>
                    </select>
                </div>
                <div class="col-12 col-sm-6 col-lg-2">
                    <label class="form-label mb-1" for="dm-tipology">Tipologia evento</label>
                    <!-- B2.1C-01E: stessa UX ricercabile dell'Account (anteprima 5). -->
                    <Select2 :model-value="bozza.tipology_id"
                             :options="tipologiaOptions"
                             :disabled="false"
                             :placeholder="bozza.tipology_id ? tipologiaEtichetta : 'Cerca tipologia...'"
                             @update:modelValue="v => bozza.tipology_id = v || (``)" />
                </div>
                <div class="col-12 col-sm-6 col-lg-2">
                    <label class="form-label mb-1" for="dm-project">Progetto</label>
                    <Select2 :model-value="bozza.project_id"
                             :api="apiProgetto"
                             :apiselected="apiProgettoSelected"
                             http-method="GET"
                             load-on-open
                             :disabled="false"
                             :placeholder="bozza.project_id ? etichettaProgetto : 'Cerca progetto...'"
                             @update:modelValue="v => bozza.project_id = v || (``)" />
                </div>
                <div class="col-12 col-sm-6 col-lg-2">
                    <!-- B2.1C-01F Localita': stesso Select2 di Cliente/Progetto (POST storico,
                         soglia 3 caratteri come l'API CORE). Nessun componente duplicato. -->
                    <label class="form-label mb-1" for="dm-location">Località</label>
                    <Select2 :model-value="bozza.location_id"
                             :api="apiLocalita"
                             :apiselected="apiLocalitaSelected"
                             :force-params="{ FORCE: 1 }"
                             load-on-open
                             :disabled="false"
                             :placeholder="bozza.location_id ? etichettaLocalita : 'Cerca località...'"
                             @update:modelValue="v => bozza.location_id = v || (``)" />
                </div>
                <div class="col-12 col-sm-6 col-lg-2">
                    <!-- B2.1C-01G-B.1 Fornitore: supplier_id = ID_PERSONA_GIURIDICA,
                         come da /theb-s2/fornitori. Anteprima via FORCE (ramo
                         dedicato nella route), soglia 3 caratteri per la ricerca. -->
                    <label class="form-label mb-1" for="dm-supplier">Fornitore</label>
                    <Select2 :model-value="bozza.supplier_id"
                             :api="apiFornitore"
                             :apiselected="apiFornitoreSelected"
                             :force-params="{ FORCE: 1 }"
                             load-on-open
                             :disabled="false"
                             :placeholder="bozza.supplier_id ? etichettaFornitore : 'Cerca fornitore...'"
                             @update:modelValue="v => bozza.supplier_id = v || (``)" />
                </div>
                <div class="col-12 col-lg-2 d-flex gap-2 justify-content-lg-end align-items-end dm-filterbar__actions">
                    <!-- APPLY ESPLICITO: unico comando che ricarica la Dashboard. -->
                    <button type="button" class="btn btn-sm btn-primary flex-fill flex-lg-fill-none"
                            :disabled="!applicabile" @click="applica">
                        <i class="ph ph-funnel me-1" aria-hidden="true"></i>Applica
                    </button>
                    <!-- RESET DEFERRED: azzera solo la bozza, 0 richieste Dashboard. -->
                    <button type="button" class="btn btn-sm btn-outline-secondary flex-fill flex-lg-fill-none"
                            @click="reset">
                        <i class="ph ph-arrow-counter-clockwise me-1" aria-hidden="true"></i>Reset
                    </button>
                </div>
            </div>

            <!-- Riepilogo dei filtri APPLICATI (non della bozza) -->
            <p class="dm-filterbar__summary" v-if="riepilogo.length">
                Filtri applicati: {{ riepilogo.join(' · ') }}
            </p>
            <p class="dm-filterbar__summary" v-else>
                Nessun filtro dimensionale applicato.
            </p>
        </div>
    </div>
</template>

<script>
import Select2 from "@/components/utils/Select2.vue";
import { VueDatePicker } from "@vuepic/vue-datepicker";

/* B2.1C-01D: questo enum vive in data(), NON in una const fuori dal componente.
   Prima era una const di modulo: il template risolve gli identificatori solo sull'istanza
   (data/props/computed/methods), quindi v-for="t in CLIENT_TYPES" rendeva ZERO opzioni.
   Vue segnalava "Property CLIENT_TYPES was accessed during render but is not defined on
   instance" e la select mostrava solo "Tutte", con un value senza corrispondenza:
   campo apparentemente vuoto. Ora e' esposto come clientTypes. */
const CLIENT_TYPES = [
    { value: "GIURIDICA", label: "Giuridica" },
    { value: "FISICA", label: "Fisica" },
];
/* Tipologie: 58 = stati progetto, 61 = tipologia evento (filters.js). */
const TIPOLOGIA_STATI = 58;
const TIPOLOGIA_EVENTO = 61;
/* Sorgenti cliente gia' usate dal gestionale (nessuna API nuova). */
const API_CLIENTE = {
    GIURIDICA: { q: "theb-s2/clienti", s: "theb-s2/clienti/selected?a=1" },
    FISICA: { q: "theb-s2/persone-fisiche", s: "theb-s2/persone-fisiche/selected?a=1" },
};
/* B2.1C-01F: Localita'. API CORE gia' esistente, POST (soglia 3 caratteri),
   risposta {id: ID_COMUNE, text: NOME}. Stesso uso di PersonaFisica/Aziende. */
const API_LOCALITA = "core/geo/comuni/select2";
const API_LOCALITA_SELECTED = "core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1";
/* B2.1C-01G-B.1: Fornitore. ID = ID_PERSONA_GIURIDICA (non ID_AZIENDA).
   FILTERS-02 / P0-01 + P1-01: l'endpoint /theb-s2/fornitori ha un contratto
   storico DIVERSO: le schermate gestionali (ConfVociPreferiteGenerali.vue,
   Attivita.vue) usano la ricerca per campi FK_ID_AZIENDA_FORNITORE e vogliono
   quindi ID_AZIENDA. Cambiare quel default le avrebbe rotte, e FILTERS-02 impone
   di non sacrificare altre sezioni.
   => la Dashboard usa due rotte DEDICATE, che restituiscono SEMPRE
   ID_PERSONA_GIURIDICA: allineate fra loro (anteprima = ricerca = resolver) e
   coerenti con il filtro backend, che confronta SA2.FK_ID_PERSONA_GIURIDICA.
   /theb-s2/fornitori non e' stato toccato. */
const API_FORNITORE = "theb-s2/fornitori/dashboard";
const API_FORNITORE_SELECTED = "theb-s2/fornitori/dashboard/selected";
const API_PROGETTO = "theb/dashboard/manager/projects";
const API_PROGETTO_SELECTED = "theb/dashboard/manager/projects/selected";

function bozzaVuota() {
    return {
        date_from: "", date_to: "", account_id: "", client_type: "", client_id: "",
        state_id: "", tipology_id: "", project_id: "", location_id: "", supplier_id: "",
    };
}
function idDaValore(v) {
    return (v === null || v === undefined || v === "") ? "" : String(v);
}

export default {
    name: "ManagerFilterBar",
    components: { Select2, VueDatePicker },
    emits: ["chiudi"],

    props: {
        /* Filtri gia' applicati, dal payload del backend. */
        applicati: { type: Object, default: () => ({}) },
        /* Stati classificati come CHIUSI dal backend. B2.1C-01D: NON limitano piu'
           le opzioni del filtro (nemmmeno "Completato"); restano disponibili per
           KPI e aggregazioni, dove sono gia' usati dal padre. */
        statiChiusi: { type: Array, default: () => [] },
        /* Filtri impostati esplicitamente dall'utente. Se null si usa "applicati".
           Dopo un Reset deve restare vuoto, senza ricomparire il periodo di default
           restituito dal backend. */
        filtriEspliciti: { type: Object, default: null },
    },

    data() {
        /* B2.1C-01E: stato dei due combobox ricercabili (Account, Tipologia evento).
           ANTEPRIMA_MAX limita le righe mostrate, NON il perimetro della ricerca:
           il filtro viene applicato sempre all'elenco completo, quindi un record
           in posizione 400 e' trovabile digitando il suo testo. */
        const ANTEPRIMA_MAX = 5;
        return {
            bozza: bozzaVuota(),
            clientTypes: CLIENT_TYPES,
            accountAperto: false, accountQuery: "",
            tipologiaAperto: false, tipologiaQuery: "",
            anteprimaMax: ANTEPRIMA_MAX,
        };
    },

    watch: {
        applicati: {
            immediate: true,
            handler(v) { this.allineaDaApplicati(v); },
        },
        /* B2.1C-01C-B: cambio lingua a Dashboard aperta.
           Il formato visualizzato cambia, la data semantica no: si riconverte
           l'ISO senza toccare la bozza. Nessuna persistenza. */
        "$root.currentLang"() {
            if (!this.applicati) return;
            this.allineaDaApplicati(this.applicati);
        },
    },

    computed: {
        /* --- ACCOUNT: root gia' caricato da core/home (nessuna API) --- */
        accountOptions() {
            const arr = this.$root && this.$root.utentiAdminAttivi;
            if (!Array.isArray(arr)) return [];
            return arr
                .filter((u) => u && u.ID_UTENTE > 0)
                .map((u) => {
                    const nome = [u.COGNOME, u.NOME].filter(Boolean).join(" ").trim();
                    return { id: String(u.ID_UTENTE), text: nome || u.USERNAME || ("#" + u.ID_UTENTE) };
                })
                .sort((a, b) => a.text.localeCompare(b.text, "it"));
        },

        /* --- STATO: tipologia 58, value CUSTOM_1, label DESCRIZIONE ---
           B2.1C-01D: nessuna esclusione. L'opzione di ricerca mostra TUTTI gli stati
           presenti nella tipologia 58: ne' in base a FLG_ATTIVO, ne' in base alla
           classificazione "chiusi". "Completato" e' classificato come chiuso ma
           deve restare selezionabile. La classificazione aperto/chiusi continua a
           valere per KPI, stati e aggregazioni della Dashboard. */
        statoOptions() {
            const f = global.filters;
            if (!f || typeof f.getOpzioniTipologiche !== "function") return [];
            return f.getOpzioniTipologiche(TIPOLOGIA_STATI)
                .map((s) => ({ id: idDaValore(s.CUSTOM_1), text: s.DESCRIZIONE }))
                .sort((a, b) => a.text.localeCompare(b.text, "it"));
        },

        /* --- TIPOLOGIA EVENTO: tipologia 61, value ID_OPZIONE_TIPOLOGICA --- */
        tipologiaOptions() {
            const f = global.filters;
            if (!f || typeof f.getOpzioniTipologiche !== "function") return [];
            return f.getOpzioniTipologiche(TIPOLOGIA_EVENTO)
                .map((t) => ({ id: idDaValore(t.ID_OPZIONE_TIPOLOGICA), text: t.DESCRIZIONE }))
                .sort((a, b) => a.text.localeCompare(b.text, "it"));
        },

        /* --- CLIENTE: api dinamica in base a client_type --- */
        apiCliente() {
            return API_CLIENTE[this.bozza.client_type]
                ? API_CLIENTE[this.bozza.client_type].q : null;
        },
        apiClienteSelected() {
            return API_CLIENTE[this.bozza.client_type]
                ? API_CLIENTE[this.bozza.client_type].s : null;
        },
        apiProgetto() { return API_PROGETTO; },
        apiFornitore() { return API_FORNITORE; },
        /* FILTERS-02 / P1-01: il resolver punta al ramo "/selected", non piu' al
           ramo di ricerca testuale. Con la ricerca, {q: ID_PERSONA_GIURIDICA}
           veniva usato come LIKE sul nome: nessun match, etichetta non risolta
           ("-" o "Loading" permanente). */
        apiFornitoreSelected() { return API_FORNITORE_SELECTED; },
        apiLocalita() { return API_LOCALITA; },
        apiLocalitaSelected() { return API_LOCALITA_SELECTED; },
        apiProgettoSelected() { return API_PROGETTO_SELECTED; },

        /* Il pulsante Applica e' sempre disponibile. */
        applicabile() {
            return true;
        },

        /* --- B: LINGUA CORRENTE ---
           Fonte: $root.currentLang, ID NUMERICO (App.vue:493, default 118). Non e' un
           codice tipo "en". Le denominazioni arrivano da $root.arrayLingue = [{ID_GEO_STATO, NOME}].
           Rilevamento inglese: confronto case-insensitive sul NOME del record corrente.
           Non viene hardcodato alcun ID lingua. */
        linguaCorrente() {
            const root = this.$root || {};
            const arr = root.arrayLingue;
            if (!Array.isArray(arr) || !arr.length) return "";
            const corrente = arr.find((l) => l && l.ID_GEO_STATO == root.currentLang);
            return corrente && corrente.NOME ? String(corrente.NOME).toLowerCase().trim() : "";
        },

        /* B2.1C-01E.1: stesso contratto di CLIENTE - valore corrente o testo segnaposto. */
        etichettaProgetto() {
            return this.bozza.project_id ? ("#" + this.bozza.project_id) : "";
        },
        /* B2.1C-01F: stesso contratto di Cliente e Progetto. */
        etichettaFornitore() {
            return this.bozza.supplier_id ? ("#" + this.bozza.supplier_id) : "";
        },
        etichettaLocalita() {
            return this.bozza.location_id ? ("#" + this.bozza.location_id) : "";
        },
        /* --- B2.1C-01E: Account ricercabile (anteprima 5, ricerca su tutto) --- */
        accountEtichetta() {
            const a = this.accountOptions.find((x) => x.id === idDaValore(this.bozza.account_id));
            return a ? a.text : "";
        },
        accountVisibili() {
            const q = this.accountQuery.trim().toLowerCase();
            const base = q ? this.accountOptions.filter((a) => a.text.toLowerCase().indexOf(q) >= 0) : this.accountOptions;
            return base.slice(0, this.anteprimaMax);
        },
        /* --- B2.1C-01E: Tipologia evento ricercabile (anteprima 5) --- */
        tipologiaEtichetta() {
            const t = this.tipologiaOptions.find((x) => x.id === idDaValore(this.bozza.tipology_id));
            return t ? t.text : "";
        },
        tipologiaVisibili() {
            const q = this.tipologiaQuery.trim().toLowerCase();
            const base = q ? this.tipologiaOptions.filter((t) => t.text.toLowerCase().indexOf(q) >= 0) : this.tipologiaOptions;
            return base.slice(0, this.anteprimaMax);
        },

        /* --- C-1: payload della richiesta Dashboard.
           - stringa vuota = filtro assente (mai "null"/"undefined" come stringa);
           - nomi e valori identici al contract 2.1.0;
           - date convertite in ISO YYYY-MM-DD (unico formato accettato da normalizzaData()).
           Nessun nuovo campo. */
        filtriDaInviare() {
            return {
                date_from: this.dataApi(this.bozza.date_from),
                date_to: this.dataApi(this.bozza.date_to),
                account_id: idDaValore(this.bozza.account_id),
                client_type: this.bozza.client_type || "",
                client_id: idDaValore(this.bozza.client_id),
                state_id: idDaValore(this.bozza.state_id),
                tipology_id: idDaValore(this.bozza.tipology_id),
                project_id: idDaValore(this.bozza.project_id),
                location_id: idDaValore(this.bozza.location_id),
                supplier_id: idDaValore(this.bozza.supplier_id),
            };
        },

        /* Riepilogo leggibile: mostra i filtri ESPLICITAMENTE applicati dall'utente.
           Dopo un Reset non deve ricomparire nulla, ne' il periodo di default
           restituito dal backend: per questo il padre passa "filtriEspliciti". */
        riepilogo() {
            const a = this.filtriEspliciti || this.applicati || {};
            const out = [];
            if (a.date_from || a.date_to) {
                /* Le date vengono dal backend in ISO: qui si mostrano nel formato
                   locale, coerenti con i due campi del pannello. */
                const da = this.dataUi(a.date_from);
                const a_ = this.dataUi(a.date_to);
                out.push("periodo " + (da || "…") + " → " + (a_ || "…"));
            }
            const acc = this.accountOptions.find((x) => x.id === idDaValore(a.account_id));
            if (acc) out.push("account: " + acc.text);
            if (a.client_type) {
                const t = CLIENT_TYPES.find((x) => x.value === a.client_type);
                out.push("cliente " + (t ? t.label : a.client_type));
            }
            if (a.client_id) out.push("cliente #" + a.client_id);
            const st = this.statoOptions.find((x) => x.id === idDaValore(a.state_id));
            if (st) out.push("stato: " + st.text);
            const ti = this.tipologiaOptions.find((x) => x.id === idDaValore(a.tipology_id));
            if (ti) out.push("tipologia: " + ti.text);
            if (a.project_id) out.push("progetto #" + a.project_id);
            if (a.location_id) out.push("localita' #" + a.location_id);
            if (a.supplier_id) out.push("fornitore #" + a.supplier_id);
            return out;
        },
    },

    methods: {
        /* --- B: formato e placeholder (metodi, non computed: chiamano il computed linguaCorrente) --- */
        linguaInglese() {
            const n = this.linguaCorrente;
            /* B2.1C-01D: confronto per prefisso sulle denominazioni effettive del
               catalogo lingua: regge anche varianti come "Inglese (UK)". */
            return n.indexOf("ingles") === 0 || n.indexOf("english") === 0;
        },
        /* Formato per VueDatePicker (token stile date-fns: dd = giorno del mese).
           Pilota sia il contenuto mostrato sia il placeholder. */
        formatoDataPicker() { return this.linguaInglese() ? "mm/dd/yyyy" : "dd/MM/yyyy"; },
        placeholderDataPicker() { return this.linguaInglese() ? "mm/dd/yyyy" : "gg/mm/aaaa"; },

        /* Formato per moment: i token sono DIVERSI (DD = giorno del mese,
           "dd" = nome abbreviato del giorno -> darebbe "Mo"). Va tenuto separato
           dal formato del date picker per non confondere i due sistemi. */
        formatoMoment() { return this.linguaInglese() ? "MM/DD/yyyy" : "DD/MM/yyyy"; },

        /* --- B: DATE, conversione bidirezionale ---
           API: sempre YYYY-MM-DD (normalizzaData() fa round-trip sul formato).
           UI: formato locale. Il parsing e' strict: un input non valido (31/02/2026)
           non viene interpretato come un'altra data ma diventa "". */
        dataApi(valore) {
            const m = global.moment;
            if (!m || !valore) return "";
            const s = String(valore).trim();
            if (s === "") return "";
            /* Se arriva gia' in ISO (dal payload) non va riletto come locale. */
            if (m(s, "YYYY-MM-DD", true).isValid()) return s;
            const d = m(s, this.formatoMoment(), true);
            return d.isValid() ? d.format("YYYY-MM-DD") : "";
        },
        /* ISO (backend) -> formato locale (UI). Non puo' generare date ambigue. */
        dataUi(iso) {
            const m = global.moment;
            if (!m || !iso) return "";
            const d = m(String(iso), "YYYY-MM-DD", true);
            return d.isValid() ? d.format(this.formatoMoment()) : "";
        },

        /* --- B2.1C-01E: metodi dei combobox ricercabili --- */
        apriAccount() { this.accountAperto = true; },
        chiudiAccount() { this.accountAperto = false; this.accountQuery = ""; },
        cercaAccount(v) { this.accountQuery = v || ""; this.accountAperto = true; },
        scegliAccount(a) { this.bozza.account_id = idDaValore(a.id); this.accountQuery = ""; this.accountAperto = false; },
        apriTipologia() { this.tipologiaAperto = true; },
        chiudiTipologia() { this.tipologiaAperto = false; this.tipologiaQuery = ""; },
        cercaTipologia(v) { this.tipologiaQuery = v || ""; this.tipologiaAperto = true; },
        scegliTipologia(t) { this.bozza.tipology_id = idDaValore(t.id); this.tipologiaQuery = ""; this.tipologiaAperto = false; },

        /* B2.1C-01C-B C-1: il pulsante Applica deve TRASMETTERE la bozza.
           Prima emetteva "applica" senza payload e il padre riusava i filtri gia'
           applicati: nessuna modifica del filtro raggiungeva mai la Dashboard API.
           Si invia una COPIA con i soli campi del contract 2.1.0 e le date in ISO. */
        applica() {
            this.$emit("applica", this.filtriDaInviare);
        },
        allineaDaApplicati(v) {
            const f = v || {};
            const b = bozzaVuota();
            /* Backend -> UI: ISO -> formato locale corrente. */
            b.date_from = this.dataUi(f.date_from);
            b.date_to = this.dataUi(f.date_to);
            b.client_type = f.client_type || "";
            ["account_id", "client_id", "state_id", "tipology_id", "project_id", "location_id", "supplier_id"].forEach((c) => {
                b[c] = idDaValore(f[c]);
            });
            this.bozza = b;
        },
        onClientTypeChange(v) {
            /* Cambiando famiglia, il cliente precedente non e' piu' valido:
               si azzera per evitare un silenzioso zero KPI. 0 richieste. */
            this.bozza.client_type = v || "";
            this.bozza.client_id = "";
        },
        reset() {
            /* B2.1C-01D RESET_MODE = IMMEDIATE: azzera subito la bozza e chiede al padre
               1 reload SENZA filtri, svuotando anche il riepilogo. Dopo il Reset non e'
               piu' necessario premere "Applica". Il pannello resta aperto. */
            this.bozza = bozzaVuota();
            this.$emit("reset-filtri");
        },
    },
}
</script>
<style scoped>
/* UI-01B - pixel tuning del FilterBar sul riferimento visivo.
   Obiettivo: pannello come FILTER TOOLBAR compatta a 2 righe, non una card alta.
   - altezza naturale: nessun height fisso, tutto deriva da padding/gap;
   - fondo azzurro/grigio piu' presente, bordo leggibile, ombra diffusa leggera;
   - label subito sopra i controlli, gap verticali ridotti;
   - controlli con altezza uniforme e stesso design system;
   - Apply/Reset nella seconda riga, larghezze sobrie;
   - testo informativo compatto, nessuna grande area vuota.
   La X (UI-01A) e' invariata: stesso posizionamento e stesse dimensioni.
   Gli elementi nativi sono nel template di questo componente (niente :deep).
   Select2 e VueDatePicker sono componenti figli: il loro DOM interno si raggiunge
   con :deep(), applicato una sola volta per selettore. */

/* Pannello compatto: altezza naturale, poco spazio morto. */
.dm-filterbar {
    position: relative;
    background: #e9eff7;
    border: 1px solid #c9d8e8;
    border-radius: 15px;
    box-shadow: 0 1px 3px rgba(16, 42, 77, .05);
    padding: 0px 16px 0px;
    margin-bottom: 0.75rem;
}

/* Label: compatte, subito sopra il controllo. */
.form-label {
    text-transform: uppercase;
    letter-spacing: .06em;
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
    margin-bottom: 7px;
}

/* Controlli nativi: altezza uniforme, bordo un po' piu' leggibile. */
.form-select,
.form-control,
.form-select-sm {
    background-color: #fff;
    border: 1px solid #b8c7d9;
    border-radius: 10px;
    color: #334155;
    font-size: 14px;
    height: 45px;
    min-height: 45px;
    padding: 10px 14px;
    box-shadow: none;
    transition: border-color .15s ease, box-shadow .15s ease;
}
.form-select:focus,
.form-control:focus {
    border-color: #8fb4dc;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, .12);
    outline: none;
    background-color: #fff;
}

/* ============================================================================
   FILTERS-02 — CONTRATTO GEOMETRICO UNICO
   Riferimento: i controlli NATIVI (.form-select.form-select-sm), gli unici la cui
   geometria e' realmente impostata dallo stile approvato:
        height 45px | border 1px #b8c7d9 | radius 10px | sfondo #fff | 14px

   PREMESSA: le regole storiche :deep(.select2-wrap …) erano MORTE.
   Select2.vue NON e' jQuery Select2: e' un wrapper di vue-multiselect 3.2, il cui
   nodo radice e' un <div> SENZA classe e che rende .multiselect, .multiselect__tags,
   .multiselect__single, .multiselect__input, .multiselect__placeholder,
   .multiselect__select. La classe .select2-wrap non compare mai nel DOM.
   Qui sotto i selettori sono quelli REALI di vue-multiselect. Tutto resta scoped:
   nessuna modifica a Select2.vue ne' al CSS globale della libreria. Nessun !important.
   ============================================================================ */

/* ---------- vue-multiselect: geometria e stati (STEP 5/6/7) ----------------
   ROOT CAUSE FILTERS-02B: le regole precedenti NON potevano funzionare.
   `src/assets/css/custom.css` (globale, tutto il gestionale) forza con !important:
       L100  .multiselect                  { min-height:32px !important; font-size:.75rem !important }
       L101  .multiselect__select          { height:32px !important }
       L102  .multiselect__tags           { min-height:32px !important; padding:6px 40px 0 8px !important;
                                             font-size:.75rem !important; border:1px solid #D1D5DB !important }
       L103  .multiselect__input, .multiselect__single { font-size:.75rem !important }
   In CSS una dichiarazione !important di autore batte QUALSIASI dichiarazione
   normale, indipendentemente dalla specificita': le regole scoped di FILTERS-02
   erano quindi annullate e il box restava ~40px (32px di min-height + 6px di
   padding-top + contenuto a 12px).

   FIX: dentro il cascade gli important di autore si confrontano per
   specificita'. Usando `.dm-filterbar :deep(.x)` la regola compilata e'
   `.dm-filterbar[data-v-x] .x` = specificita' (0,3,0), che vince su (0,1,0) di
   custom.css. L'!important e' quindi qui NECESSARIO e dimostrato, non una scorciatoia,
   ed e' limitato alle 5 sole proprieta' che custom.css forzava.
   custom.css NON viene modificato: e' condiviso da tutto il gestionale. */

/* Wrapper esterno: custom.css lo schiaccia a 32px. */
.dm-filterbar :deep(.multiselect) {
    min-height: 45px !important;
    font-size: 14px !important;
    padding-left: 0;
    padding-right: 0;
    background-color: transparent;
    border-radius: 0;
    align-items: center;
    box-sizing: border-box;
}

/* IL BOX VISIBILE: e' questo elemento che disegna il rettangolo (ha il bordo). */
.dm-filterbar :deep(.multiselect__tags) {
    min-height: 45px !important;
    padding: 0 12px 0 14px !important;
    font-size: 14px !important;
    border: 1px solid #b8c7d9 !important;
    border-radius: 10px;
    background: #fff;
    color: #334155;
    /* flex + wrap: centra verticalmente il contenuto, ma quando il menu e' aperto
       l'input inline (width:100%) va a capo come nel layout block della libreria.
       min-height e non height: nello stato aperto il box puo' crescere. */
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    box-sizing: border-box;
    transition: border-color .15s ease, box-shadow .15s ease;
}

/* La libreria stacca i bordi inferiori all'apertura. Il dropdown qui e' teleported
   su body, quindi i bordi restano arrotondati sempre. */
.dm-filterbar :deep(.multiselect--active:not(.multiselect--above) .multiselect__tags) {
    border-bottom-left-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
    border-color: #8fb4dc !important;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, .12);
}

.dm-filterbar :deep(.multiselect__tags:hover) {
    border-color: #a6bcd6 !important;
}

/* Testo selezionato e input: custom.css li schiaccia a 12px. */
.dm-filterbar :deep(.multiselect__input),
.dm-filterbar :deep(.multiselect__single) {
    font-size: 14px !important;
    line-height: 20px;
    color: #334155;
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    margin: 0;
    width: 100%;
    min-width: 0;
    /* nomi lunghi (es. codice + descrizione progetto): una riga con ellipsis,
       senza far crescere l'altezza del controllo. */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Il placeholder aveva margin-bottom 10px + padding-top 2px: e' cio' che
   spostava il testo rispetto ai controlli vicini. */
.dm-filterbar :deep(.multiselect__placeholder) {
    font-size: 14px;
    line-height: 20px;
    color: #94a3b8;
    margin-bottom: 0;
    padding-top: 0;
    padding-left: 0;
    width: 100%;
}

/* Freccia: custom.css la blocca a 32px. */
.dm-filterbar :deep(.multiselect__select) {
    height: 43px !important;
    width: 34px;
    right: 0;
    top: 1px;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

/* Stato disabilitato (Cliente senza Tipologia cliente): STESSA geometria del
   controllo attivo, cambiano solo i colori. Si neutralizzano i due effetti della
   libreria che rompevano l'uniformita': opacity .6 e sfondo #ededed. */
.dm-filterbar :deep(.multiselect--disabled) {
    opacity: 1;
    background-color: transparent;
    pointer-events: none;
}
.dm-filterbar :deep(.multiselect--disabled .multiselect__tags) {
    background: #f1f5f9 !important;
    border-color: #d7dee8 !important;
    box-shadow: none;
}
.dm-filterbar :deep(.multiselect--disabled .multiselect__single),
.dm-filterbar :deep(.multiselect--disabled .multiselect__placeholder) {
    color: #94a3b8;
    background: transparent;
}
.dm-filterbar :deep(.multiselect--disabled .multiselect__select) {
    background: transparent;
    color: #b6c2d0;
}

/* ---------- VueDatePicker: UN SOLO BOX (STEP 4) ----------------------------
   Root cause FILTERS-01: le regole storiche puntavano a .dp__main_input e
   .dp__btn_toggle, classi INESISTENTI in @vuepic/vue-datepicker v12 (0 occorrenze
   sia in main.css sia in vue-datepicker.js): erano regole MORTE e il vero input
   (.dp__input) conservava il box della libreria (border #ddd, radius 4px, ~38px,
   sfondo e padding propri) DENTRO il wrapper .dp__main (border #b8c7d9,
   radius 10px, 45px) => doppio bordo.

   DOM reale v12 con text-input:
       .dp__main (wrapper radice) > .dp__input_wrap > .dp__input (input reale)

   Fix: UNA SOLA scatola visibile, .dp__main; .dp__input diventa il testo puro,
   senza box proprio, centrato dal flex del wrapper. */
:deep(.dp__main) {
    min-height: 45px;
    width: 100%;
    border: 1px solid #b8c7d9;
    border-radius: 10px;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    transition: border-color .15s ease, box-shadow .15s ease;
    /* FILTERS-02C — FIX FUNZIONALE (menu non visibile al click).
       `overflow: hidden` era presente gia' PRIMA di FILTERS-02 e serviva solo a
       ritagliare gli angoli quadrati del vecchio box interno (.dp__main_input,
       che aveva bordo proprio) dentro il raggio 10px del wrapper.
       Oggi il box interno NON ha piu' bordo ne' sfondo: .dp__main e' l'unico
       rettangolo, quindi overflow:hidden non ha piu' alcuna funzione visiva.

       Il danno reale: il calendario NON e' teletrasportato. In
       @vuepic/vue-datepicker v12 il target si calcola con
           z = computed(() => e.teleport ? ... : undefined)
       e il template usa <Teleport :to="z" :disabled="!z">. ManagerFilterBar NON
       passa la prop `teleport`, quindi z e' undefined, `disabled` e' true e il
       menu viene renderizzato IN PLACE dentro .dp__main: con overflow:hidden
       veniva creato e immediatamente CLIPPATO (caso E).
       Non e' un problema di z-index (.dp--menu-wrapper ha z-index:99999) ne' di
       clipping da .card/.card-body (nessuno dei due ha overflow:hidden).

       => si rimuove: era un residuo del layout a due box. */
    overflow: visible;
}
:deep(.dp__main:hover) {
    border-color: #a6bcd6;
}

/* Il vero input: nessun box, nessun bordo, testo centrato dal flex del wrapper.
   Padding solo orizzontale: a sinistra lo spazio dell'icona calendario
   (--dp-input-icon-padding = 35px), a destra quello del pulsante clear.
   FILTERS-02B: custom.css L320 forza `.dp__input { font-size:0.75rem !important }`,
   quindi anche il DatePicker scriveva a 12px mentre gli altri controlli a 14px.
   Stessa tecnica del multiselect: !important + selettore piu' specifico. */
.dm-filterbar :deep(.dp__input) {
    border: none;
    outline: none;
    background: transparent;
    box-shadow: none;
    border-radius: 0;
    color: #334155;
    font-size: 14px !important;
    line-height: 20px;
    min-height: 0;
    height: auto;
    width: 100%;
    /* 36px = 12px di stacco dal bordo + 16px di icona + 8px di respiro.
       30px a destra lascia spazio al pulsante di clear (.dp--clear-btn e'
       posizionato a destra assoluta). */
    padding: 0 30px 0 36px;
    margin: 0;
}
/* FILTERS-02C: la libreria imposta `.dp__input::placeholder { opacity:.7 }`,
   quindi il testo "gg/mm/aaaa" risultava piu' sbiadito dei placeholder degli
   altri filtri ("Cerca account...", "Cerca tipologia...", "Cerca progetto..."),
   che non hanno opacity. Con opacity:1 e lo stesso colore dei multiselect
   (.multiselect__placeholder = #94a3b8) la resa torna coerente, mantenendo
   la distinzione semantica placeholder / valore inserito (#334155). */
.dm-filterbar :deep(.dp__input::placeholder) {
    color: #94a3b8;
    opacity: 1;
}
:deep(.dp__input:focus) {
    outline: none;
}

/* Icona calendario: la libreria la centra con top 50% + translateY, ma con
   font-size 1rem e padding 6px 12px era piu' alta del box. Qui viene ricentrata
   sulla nuova altezza di 45px. */
/* Icona calendario — FILTERS-02C.1 (correzione dimensione).
   DOM REALE (dal template compilato di @vuepic/vue-datepicker v12):
       Re(t(Kt), { class: "dp__input_icon dp__input_icons", onClick: toggle })
   `Kt` restituisce createVNode("svg", { class: "dp__icon", viewBox: "0 0 32 32",
   fill: "currentColor" }) e `class` arriva come fallthrough attr, quindi Vue
   lo UNISCE: l'elemento e' UN SOLO <svg class="dp__icon dp__input_icon
   dp__input_icons">. NON esiste un wrapper esterno con dentro l'SVG.

   FILTERS-02C aveva scritto due regole pensando al contrario:
     - `.dp__main .dp__input_icons .dp__icon` -> selettore DISCENDENTE, ma
       le due classi sono sullo STESSO elemento: non matchava MAI, quindi
       l'SVG restava senza width/height;
     - `.dp__main .dp__input_icons` -> matchava l'SVG stesso e gli imposed
       height:43px + padding + box-sizing:content-box.
   Un <svg> senza width/height e' un elemento sostitutivo senza dimensioni
   intrinseche: si espande per riempire il contenitore. Risultato: icona alta
   ~43px che occupa quasi tutto il box e si sovrappone a "gg/mm/aaaa".

   FIX qui sotto: una sola regola sull'elemento reale (l'SVG), che gli dà una
   dimensione definitiva e lo posiziona. Il centramento verticale resta quello
   della libreria (top:50% + translateY(-50%)), che con un'altezza definita
   funziona correttamente. */
.dm-filterbar :deep(.dp__main .dp__input_icons) {
    width: 16px;
    height: 16px;
    padding: 0;
    margin: 0;
    display: inline-block;
    box-sizing: content-box;
    inset-inline-start: 12px;   /* stacco dal bordo, come il padding-left dei nativi */
    color: #64748b;
}
.dm-filterbar :deep(.dp--clear-btn) {
    color: #94a3b8;
}

:deep(.dp__outer_menu_wrap) {
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(16, 42, 77, .12);
}

/* Apply / Reset: nella stessa riga dei controlli, larghezze sobrie. */
.dm-filterbar__actions {
    margin-bottom: 0;
}
.dm-filterbar__actions .btn {
    height: 45px;
    min-height: 45px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
    padding: 10px 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    white-space: nowrap;
}
.dm-filterbar__actions .btn-primary {
    width: 160px;
    max-width: 160px;
}
.dm-filterbar__actions .btn-outline-secondary {
    width: 140px;
    max-width: 140px;
    background-color: #fff;
    border: 1px solid #b8c7d9;
    color: #475569;
}
.dm-filterbar__actions .btn-outline-secondary:hover,
.dm-filterbar__actions .btn-outline-secondary:focus {
    background-color: #eef4fb;
    border-color: #8fb4dc;
    color: #334155;
}

/* Griglia: gap verticale ridotto, contenuto aderente. */
.row {
    --bs-gutter-x: 0.75rem;
    --bs-gutter-y: 0.75rem;
}

/* Testo informativo: compatto, discreto, nessuna fascia alta. */
.dm-filterbar__summary {
    font-size: 13px;
    line-height: 1.35;
    margin: 10px 0 0;
    color: #64748b;
}

/* X: invariata da UI-01A (solo il pannello e' stato compattato). */
.dm-filterbar__close {
    position: absolute;
    top: -14px;
    right: -12px;
    width: 38px;
    height: 38px;
    min-width: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #c9d8e8;
    color: #64748b;
    font-size: 18px;
    line-height: 1;
    z-index: 5;
    box-shadow: 0 2px 6px rgba(16, 42, 77, .10);
    transition: background-color .15s ease, color .15s ease, box-shadow .15s ease;
}
.dm-filterbar__close i {
    display: block;
    line-height: 1;
    font-size: 18px;
    pointer-events: none;
}
.dm-filterbar__close:hover {
    background: #eef4fb;
    color: #334155;
    box-shadow: 0 3px 9px rgba(16, 42, 77, .14);
}
.dm-filterbar__close:focus,
.dm-filterbar__close:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, .30);
}

/* Responsive: su viewport stretti i controlli vanno a capo naturalmente. */
@media (max-width: 991.98px) {
    .dm-filterbar__actions .btn-primary,
    .dm-filterbar__actions .btn-outline-secondary {
        width: auto;
        max-width: none;
    }
}
@media (max-width: 575.98px) {
    .dm-filterbar {
        padding: 12px 12px 6px;
    }
    .dm-filterbar__close {
        right: -6px;
        top: -12px;
        width: 34px;
        height: 34px;
        min-width: 34px;
        font-size: 16px;
    }
}
</style>